import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { createGithubConfiguration } from '@/lib/queries/integrations/scm/github';
import { preLoadDefaultProject } from '@/lib/queries/project';

import { GithubInstallationPending } from './-components/GithubInstallationPending';
import { GITHUB_TOKEN_SESSION_KEY } from './-constants';

export const Route = createFileRoute('/github-callback/installed')({
  component: RouteComponent,
  validateSearch: search =>
    z
      .object({
        installation_id: z.coerce.string(),
      })
      .transform(s => ({ installationId: s.installation_id }))
      .parse(search),
  beforeLoad: () => {
    const githubToken = sessionStorage.getItem(GITHUB_TOKEN_SESSION_KEY);

    if (githubToken === null) {
      throw redirect({ to: '/' });
    }

    return { githubToken };
  },
  loader: async ({ context }) => {
    const defaultProject = await preLoadDefaultProject({ context });

    try {
      await createGithubConfiguration(defaultProject.id, context.githubToken);
    } catch (e) {
      console.error(e);
      context.toast({
        title: 'githubCallback.installationError',
        variant: 'destructive',
      });

      throw redirect({ to: '/' });
    }
  },
  pendingComponent: GithubInstallationPending,
});

function RouteComponent() {
  return (
    <Navigate
      to="/integrations"
      search={{
        github: 'installed',
      }}
    />
  );
}
